import React, {Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import reportWebVitals from './reportWebVitals';
import 'src/services/i18n/i18n';
import FilkersLoading from "src/components/commons/FilkersLoading";


ReactDOM.render(
    <React.StrictMode>
        <Suspense fallback={<FilkersLoading/>}>
            <App/>
        </Suspense>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
